<template>
  <div class="whether">
    <div id="he-plugin-simple"></div>
  </div>
</template>

<script>
  export default {
    data(){
      return{

      }
    },
    mounted() {
      window.WIDGET = {
        "CONFIG": {
          "modules": "201",
          "background": "4",
          "backgroundColor": "00B196",
          "tmpColor": "FFFFFF",
          "tmpSize": "26",
          "cityColor": "FFFFFF",
          "citySize": "16",
          "aqiColor": "FFFFFF",
          "aqiSize": "26",
          "weatherIconSize": "38",
          "alertIconSize": "18",
          "padding": "10px 10px 10px 10px",
          "shadow": "0",
          "language": "auto",
          "fixed": "false",
          "vertical": "bottom",
          "horizontal": "left",
          "city": "CN101200907",
          "key": "fbf57671ad6e48fa84ddf4c25799077b"
        }
      }
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://widget.qweather.net/simple/static/js/he-simple-common.js?v=2.0'
      document.getElementsByTagName('head')[0].appendChild(script)
    },
    methods: {

    },
    filters: {

    }
  }
</script>

<style scoped>
  .whether{
    position: relative;
    z-index: 99;
    display: flex;
    justify-content: flex-start;
    margin-left: 100px;
  }

</style>



// WEBPACK FOOTER //
// src/components/timeWeather.vue